import { useTranslation } from 'react-i18next';

import { BillingElement } from '@shared/dream-components';

import { useBillingContext } from '~/context/SubscriptionManagement';

/**
 * Renders the personal billing card on the General tab — invoice history, payment method /
 * billing details, and the "update billing" button that opens the Stripe customer portal.
 * Everything comes from `BillingProvider` via context. Pure UI, no props, no data logic.
 */
export const BillingSection = () => {
  const { t } = useTranslation();
  const {
    showBillingDetails,
    isLoadingBillingSummary,
    isUpdateButtonDisabled,
    billingData,
    trialDurationLabel,
    onClickUpdateBilling,
  } = useBillingContext();

  if (!showBillingDetails) {
    return null;
  }

  return (
    <BillingElement
      isLoading={isLoadingBillingSummary}
      isUpdateButtonDisabled={isUpdateButtonDisabled}
      element={{
        type: 'billing',
        attrs: {
          data: billingData,
        },
      }}
      onClickUpdate={onClickUpdateBilling}
      translations={{
        'billing.summary.title': t('billing.summary.title'),
        'billing.summary.last_payment_heading': t('billing.summary.last_payment_heading'),
        'billing.summary.last_timestamp_prefix': t('billing.summary.last_timestamp_prefix'),
        'billing.summary.next_heading': t('billing.summary.next_heading'),
        'billing.summary.next_timestamp_prefix': t('billing.summary.next_timestamp_prefix'),
        'billing.summary.n_a': t('billing.summary.n_a'),
        'billing.current_plan.title': t('billing.current_plan.title'),
        'billing.summary.intervals.month': t('billing.summary.intervals.month'),
        'billing.summary.intervals.quarter': t('billing.summary.intervals.quarter'),
        'billing.summary.intervals.year': t('billing.summary.intervals.year'),
        'billing.summary.intervals.one_time': t('billing.summary.intervals.one_time'),
        'billing.details.update_button_label': t('billing.details.update_button_label'),
        'billing.details.show_address_button_label': t('billing.details.show_address_button_label'),
        'billing.details.payment_method_heading': t('billing.details.payment_method_heading'),
        'billing.details.no_card': t('billing.details.no_card'),
        'billing.summary.paid_trial.current_heading': t('billing.summary.paid_trial.current_heading'),
        'billing.summary.paid_trial.current_timestamp_prefix': t('billing.summary.paid_trial.current_timestamp_prefix'),
        'billing.summary.paid_trial.trial_duration_label': trialDurationLabel,
      }}
    >
      {null}
    </BillingElement>
  );
};
